import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { PatientsState, PatientsStore } from './patients.store';

@Injectable({ providedIn: 'root' })
export class PatientsQuery extends QueryEntity<PatientsState> {
  protected store: PatientsStore;

  constructor() {
    const store = inject(PatientsStore);

    super(store);

    this.store = store;
  }
}
